/*
Fork addition: board grid shared by the blueprint panel, item placement
and the surface layout. GRID_SIZE divides the surface margin step (250px)
exactly, so grid lines always align with board coordinates at any scroll
position without extra offset compensation.
*/
import {Point, type ReadonlyPointType} from './geometry';

export const GRID_SIZE = 25;

export function snapValueToGrid(value: number): number {
    return Math.round(value / GRID_SIZE) * GRID_SIZE;
}

export function snapPointToGrid(point: ReadonlyPointType): Point {
    return Point.assign({
        x: snapValueToGrid(point.x),
        y: snapValueToGrid(point.y),
    });
}
